export const replaceSpaceWithUnderscore = function(string) {
    return string.replace(/\s+/g, '_')
}

export const isStringSafe = function(string) {
    let regex = /^[a-zA-Z0-9_-]+$/g
    return regex.test(string)
}

export const slugifyString = function(text) {
    text = text
        .toString()
        .toLowerCase()
        .trim()

    const sets = [
        { to: 'a', from: '[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶἀ]' },
        { to: 'c', from: '[ÇĆĈČ]' },
        { to: 'd', from: '[ÐĎĐÞ]' },
        { to: 'e', from: '[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]' },
        { to: 'g', from: '[ĜĞĢǴ]' },
        { to: 'h', from: '[ĤḦ]' },
        { to: 'i', from: '[ÌÍÎÏĨĪĮİỈỊ]' },
        { to: 'j', from: '[Ĵ]' },
        { to: 'ij', from: '[Ĳ]' },
        { to: 'k', from: '[Ķ]' },
        { to: 'l', from: '[ĹĻĽŁ]' },
        { to: 'm', from: '[Ḿ]' },
        { to: 'n', from: '[ÑŃŅŇ]' },
        { to: 'o', from: '[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]' },
        { to: 'oe', from: '[Œ]' },
        { to: 'p', from: '[ṕ]' },
        { to: 'r', from: '[ŔŖŘ]' },
        { to: 's', from: '[ßŚŜŞŠȘ]' },
        { to: 't', from: '[ŢŤ]' },
        { to: 'u', from: '[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]' },
        { to: 'w', from: '[ẂŴẀẄ]' },
        { to: 'x', from: '[ẍ]' },
        { to: 'y', from: '[ÝŶŸỲỴỶỸ]' },
        { to: 'z', from: '[ŹŻŽ]' },
        { to: '-', from: "[·/_,:;']" },
    ]

    sets.forEach(set => {
        text = text.replace(new RegExp(set.from, 'gi'), set.to)
    })

    return text
        .replace(/\s+/g, '_') // Replace spaces with -
        .replace(/[^-a-zа-я\u0370-\u03ff\u1f00-\u1fff]+/g, '') // Remove all non-word chars
        .replace(/--+/g, '_') // Replace multiple - with single -
        .replace(/^-+/, '') // Trim - from start of text
        .replace(/-+$/, '') // Trim - from end of text
}

export const splitUrlsIntoArray = function(textString) {
    if (!textString) {
        // Return empty array if input string doesn't exist or is empty
        return []
    }

    // Regular expression to split the string by spaces, commas, newlines, and their combinations
    const splitRegex = /[\s,]+/

    // Split the string using the updated regular expression
    const potentialUrls = textString.split(splitRegex)

    const httpRegex = /^http/

    const validUrls = potentialUrls.filter(url => httpRegex.test(url))

    return validUrls
}

export const replaceAccents = function(str) {
    // Verifies if the String has accents and replace them
    if (str.search(/[\xC0-\xFF]/g) > -1) {
        str = str
            .replace(/[\xC0-\xC5]/g, 'A')
            .replace(/[\xC6]/g, 'AE')
            .replace(/[\xC7]/g, 'C')
            .replace(/[\xC8-\xCB]/g, 'E')
            .replace(/[\xCC-\xCF]/g, 'I')
            .replace(/[\xD0]/g, 'D')
            .replace(/[\xD1]/g, 'N')
            .replace(/[\xD2-\xD6\xD8]/g, 'O')
            .replace(/[\xD9-\xDC]/g, 'U')
            .replace(/[\xDD]/g, 'Y')
            .replace(/[\xDE]/g, 'P')
            .replace(/[\xE0-\xE5]/g, 'a')
            .replace(/[\xE6]/g, 'ae')
            .replace(/[\xE7]/g, 'c')
            .replace(/[\xE8-\xEB]/g, 'e')
            .replace(/[\xEC-\xEF]/g, 'i')
            .replace(/[\xF1]/g, 'n')
            .replace(/[\xF2-\xF6\xF8]/g, 'o')
            .replace(/[\xF9-\xFC]/g, 'u')
            .replace(/[\xFE]/g, 'p')
            .replace(/[\xFD\xFF]/g, 'y')
    }
}

export const isValidUrl = function(string) {
    try {
        new URL(string)
        return true
    } catch (e) {
        return false
    }
}

export const getUrlTypeAndCode = function(url) {
    try {
        // Parse the URL
        const parsedUrl = new URL(url)

        // Object to hold the result
        const result = {
            type: null,
            code: null,
        }

        // Check for Amazon ASIN code
        if (/amazon\.[a-z.]{2,}$/.test(parsedUrl.hostname)) {
            result.type = 'amazon'
            const asinMatch = parsedUrl.pathname.match(/\/dp\/(\w{10})/)
            result.code = asinMatch ? asinMatch[1] : null
        }
        // Check for YouTube video code
        else if (
            (parsedUrl.hostname === 'www.youtube.com' ||
                parsedUrl.hostname === 'youtube.com' ||
                parsedUrl.hostname === 'm.youtube.com') &&
            parsedUrl.pathname === '/watch'
        ) {
            result.type = 'youtube'
            result.code = parsedUrl.searchParams.get('v')
        }
        // Check for YouTube video code
        else if (
            (parsedUrl.hostname === 'www.youtube.com' ||
                parsedUrl.hostname === 'youtube.com' ||
                parsedUrl.hostname === 'm.youtube.com') &&
            parsedUrl.pathname === '/playlist'
        ) {
            result.type = 'youtubePlaylist'
            result.code = parsedUrl.searchParams.get('list')
        } else if (
            (parsedUrl.hostname === 'www.youtube.com' ||
                parsedUrl.hostname === 'youtube.com' ||
                parsedUrl.hostname === 'm.youtube.com') &&
            parsedUrl.pathname &&
            parsedUrl.pathname.indexOf('/@') == 0
        ) {
            result.type = 'youtubeChannel'
            result.code = ''
        }
        // Check for shortened YouTube URL
        else if (parsedUrl.hostname === 'youtu.be') {
            result.type = 'youtube'
            const videoIdMatch = parsedUrl.pathname.match(/^\/([\w-]{11})/)
            result.code = videoIdMatch ? videoIdMatch[1] : null
        }
        // Check for Wikipedia
        else if (/wikipedia\.org$/.test(parsedUrl.hostname)) {
            result.type = 'wikipedia'
            // Wikipedia does not have a unique code in the URL to extract
        }
        // Check for X
        else if (
            parsedUrl.hostname === 'www.x.com' ||
            parsedUrl.hostname === 'x.com' ||
            parsedUrl.hostname === 'm.x.com'
        ) {
            result.type = 'twitter'
        }
        // Check for RSS feed by path
        else if (
            parsedUrl.pathname.includes('.rss') ||
            parsedUrl.pathname.includes('/feed') ||
            parsedUrl.pathname.includes('.xml') ||
            parsedUrl.pathname.includes('rss') ||
            parsedUrl.pathname.includes('xml')
        ) {
            result.type = 'rss'
            // RSS feeds do not have a unique code in the URL to extract
        }

        // Return the result
        return result
    } catch (e) {
        // If the URL is invalid or there's an error, return null values
        return { type: null, code: null }
    }
}
